export class EventContext {
  constructor(contextId) {
    this.contextId = contextId;
  }
}